import dayjs from "dayjs";

/**
 * exIQtive's standard task date format: MMM D, YYYY (e.g. "Jan 1, 2024").
 * Used for the deadline / done-on date line under the task status badge.
 * Returns "" for null / empty / invalid input so callers can hide the line.
 */
export function formatStatusDate(value) {
  if (value == null || value === "") return "";
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("MMM D, YYYY") : "";
}
